import type { FormValues } from "../types";

const STORAGE_KEY = "upside-mentor-application:v1";
const TTL_DAYS = 14;
const TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;

type Persisted = {
  savedAt: number;
  sectionIndex: number;
  values: FormValues;
};

export function loadPersisted(): Persisted | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Persisted;
    if (Date.now() - parsed.savedAt > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function savePersisted(sectionIndex: number, values: FormValues): number {
  const savedAt = Date.now();
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ savedAt, sectionIndex, values } satisfies Persisted),
    );
  } catch {
    // localStorage full or blocked — silent fallback per brief
  }
  return savedAt;
}

export function clearPersisted(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
}
